export const MENU_GOAL_CATEGORY_SECTION = {
  SALES: 'SALES',
  LEADS: 'Leads',
  OTHER: 'OTHER',
};

export const ActionOperatorEnum = [
  'NoExpression',
  'EqualsTo',
  'BeginsWith',
  'RegularExpression',
  'Contains',
];

export const ValueOperatorEnum =
[
  'NoValue',
  'EqualTo',
  'LessThan',
  'GreaterThan',
];

export const LabelOperatorEnum = [
  'NoExpression',
  'EqualsTo',
  'BeginsWith',
  'RegularExpression',
  'Contains',
];

export const CategoryOperatorEnum = [
  'NoExpression',
  'EqualsTo',
  'BeginsWith',
  'RegularExpression',
  'Contains',
];

export const GoalValueTypeEnum = [
  'FixedValue',
  'VariantValue',
  'NoValue',
];

export const AttributionModelTypeEnum = [
  'Default',
  'External',
  'LastTouch',
];

export const ConversionCountTypeEnum = [
  'All',
  'Unique',
];

export const GoalTypeEnum = [
  'DestinationGoal',
  'EventGoal',
];

export const GoalStatusEnum = [
  'Active',
  'Paused',
];

export const GOAL_CATEGORY = {
  PURCHASE: 'Purchase',
  ADD_TO_CART: 'AddToCart',
  BEGIN_CHECKOUT: 'BeginCheckout',
  SUBSCRIBE: 'Subcribe',
  SUBMIT_LEAD_FORM: 'SubmitLeadForm',
  BOOK_APPOINTMENT: 'BookAppointment',
  SIGNUP: 'Signup',
  REQUEST_QUOTE: 'RequestQuote',
  GET_DIRECTIONS: 'GetDirections',
  OUTBOUND_CLICK: 'OutboundClick',
  CONTACT: 'Contact',
  PAGE_VIEW: 'PageView',
  OTHER: 'Other',
  DOWNLOAD: 'Download',
  IN_STORE_VISIT: 'InStoreVisit',
};

export const MenuCategoryMapping = {
  [MENU_GOAL_CATEGORY_SECTION.SALES]: [
    GOAL_CATEGORY.PURCHASE,
    GOAL_CATEGORY.ADD_TO_CART,
    GOAL_CATEGORY.BEGIN_CHECKOUT,
    GOAL_CATEGORY.SUBSCRIBE,
  ],
  [MENU_GOAL_CATEGORY_SECTION.LEADS]: [
    GOAL_CATEGORY.SUBMIT_LEAD_FORM,
    GOAL_CATEGORY.BOOK_APPOINTMENT,
    GOAL_CATEGORY.SIGNUP,
    GOAL_CATEGORY.REQUEST_QUOTE,
    GOAL_CATEGORY.GET_DIRECTIONS,
    GOAL_CATEGORY.OUTBOUND_CLICK,
  ],
  [MENU_GOAL_CATEGORY_SECTION.OTHER]: [
    GOAL_CATEGORY.CONTACT,
    GOAL_CATEGORY.PAGE_VIEW,
    GOAL_CATEGORY.DOWNLOAD,
    GOAL_CATEGORY.IN_STORE_VISIT,
    GOAL_CATEGORY.OTHER,
  ],
};

export const GoalCategoriesConfig = {
  [GOAL_CATEGORY.PURCHASE]: {
    title: _TL_('Purchase'),
    description: _TL_('The completion of an order, usually signified by receiving an order/purchase confirmation.'),
    defaultAction: 'purchase',
    helpId: 'pop_BA_UET_AutoConversions_Purchase',
  },
  [GOAL_CATEGORY.ADD_TO_CART]: {
    title: _TL_('Add to cart'),
    description: _TL_('The addition of an item to the shopping cart (such as selecting  the Add to cart button on the website).'),
    defaultAction: 'add_to_cart',
    helpId: 'pop_BA_UET_AutoConversions_AddToCart ',
  },
  [GOAL_CATEGORY.BEGIN_CHECKOUT]: {
    title: _TL_('Begin checkout'),
    description: _TL_('The start of the checkout process.'),
    defaultAction: 'begin_checkout',
    helpId: 'pop_BA_UET_AutoConversions_BeginCheckout',
  },
  [GOAL_CATEGORY.SUBSCRIBE]: {
    title: _TL_('Subscribe'),
    description: _TL_('The start of a paid subscription to a product or service you offer.'),
    defaultAction: 'subscribe',
    helpId: 'pop_BA_UET_AutoConversions_Subscribe',
  },
  [GOAL_CATEGORY.SUBMIT_LEAD_FORM]: {
    title: _TL_('Submit lead form'),
    description: _TL_('The submission of information by a potential customer for a product or service you offer'),
    defaultAction: 'submit_form',
    helpId: 'pop_BA_UET_AutoConversions_SubmitLeadForm',
  },
  [GOAL_CATEGORY.BOOK_APPOINTMENT]: {
    title: _TL_('Book appointment'),
    description: _TL_('The booking of an appointment with your business'),
    defaultAction: 'book_appointment',
    helpId: 'pop_BA_UET_AutoConversions_BookAppointment',
  },
  [GOAL_CATEGORY.SIGNUP]: {
    title: _TL_('Sign-up'),
    description: _TL_('The completion of a form to sign up for a service you offer (such as a newsletter)'),
    defaultAction: 'sign_up',
    helpId: 'pop_BA_UET_AutoConversions_SignUp',
  },
  [GOAL_CATEGORY.REQUEST_QUOTE]: {
    title: _TL_('Request quote'),
    description: _TL_('The request from a customer to get more details of the product or service you offer, along with pricing information'),
    defaultAction: 'request_quote',
    helpId: 'pop_BA_UET_AutoConversions_RequestQuote',
  },
  [GOAL_CATEGORY.GET_DIRECTIONS]: {
    title: _TL_('Get direction'),
    description: _TL_('When a person wants to find one of your locations with the intention of visiting'),
    defaultAction: 'look_at_directions',
    helpId: 'pop_BA_UET_AutoConversions_GetDirections',
  },
  [GOAL_CATEGORY.OUTBOUND_CLICK]: {
    title: _TL_('Outbound click'),
    description: _TL_('When a customer is redirected to an external website'),
    defaultAction: 'outbound_click',
    helpId: 'pop_BA_UET_AutoConversions_OutboundClick',
  },
  [GOAL_CATEGORY.CONTACT]: {
    title: _TL_('Contact'),
    description: _TL_('When a customer contacts your business via telephone/SMS, email, chat, or any other type of contact'),
    defaultAction: 'contact_us',
    helpId: 'pop_BA_UET_AutoConversions_Contact',
  },
  [GOAL_CATEGORY.PAGE_VIEW]: {
    title: _TL_('Page view'),
    description: _TL_('A visit to a webpage that you have identified as being important to your business, such as a product page or search result'),
    defaultAction: 'page_view',
  },
  [GOAL_CATEGORY.OTHER]: {
    title: _TL_('Other'),
    description: _TL_('Use this if the other categories don\'t match the actions you are tracking as a conversion'),
    defaultAction: 'other',
  },
  [GOAL_CATEGORY.DOWNLOAD]: {
    title: _TL_('Download'),
    description: _TL_('Use this if the other categories don\'t match the actions you are tracking as a conversion'),
    defaultAction: 'download',
  },
  [GOAL_CATEGORY.IN_STORE_VISIT]: {
    title: _TL_('Store visit'),
  },
};

export const GoalMenuI18nKey2value = {
  /* submenu options */
  [MENU_GOAL_CATEGORY_SECTION.SALES]: _TL_('Sales'),
  [MENU_GOAL_CATEGORY_SECTION.LEADS]: _TL_('Leads'),
  [MENU_GOAL_CATEGORY_SECTION.OTHER]: _TL_('Other'),
};
